import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDownloadLegalClientQuestionnaireLazyQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { Base64FileData } from 'api/types/data';

export const useDownloadLegalClientQuestionnaire = () => {
  const [handler, { data, loading, error: apolloError }] =
    useDownloadLegalClientQuestionnaireLazyQuery();

  const error = useError(apolloError);

  return {
    downloadLegalClientQuestionnaire: useCallback(
      async (legalClientId: string) => {
        const res = await handler({
          variables: {
            id: legalClientId,
          },
        });
        return res.data?.legalClientQuestionnaire as Base64FileData | undefined;
      },
      [handler]
    ),
    data: data?.legalClientQuestionnaire as Base64FileData | undefined,
    loading,
    error,
  };
};
